module.exports = __webpack_public_path__ + "static/media/unimake_solucoes.0414cb4b.webp";